export const MAX_REMEMBERED_TOTALS = 3;

export const rememberedTotals = (
	remembered: Map<string, Array<unknown>>,
	key: string,
	totals: Array<unknown> | null
): Map<string, Array<unknown>> => {
	const updated = new Map(remembered);

	if (totals === null) {
		updated.delete(key);
	} else {
		updated.delete(key);
		updated.set(key, totals);
	}

	return new Map([...updated].slice(-MAX_REMEMBERED_TOTALS));
};
